/**
 * useStripeDashboard — « Suivre mes paiements » / « Mes paiements » du tuteur, port de
 * `StripeExpressDashboardButton.js` : l'adresse du tableau Stripe se demande
 * (`getDashboardExpressUrl`), puis s'ouvre hors de l'app ; `opening` fait tourner le geste pendant la
 * demande (l'ancien « Redirection... »). Un refus se dit par `onError`, à l'endroit que l'écran
 * choisit : l'ancien bouton n'avait que la boîte de l'intercepteur réseau de l'app, qui se tait sous
 * l'espace tuteur (`useOwnNetworkFailuresWhileFocused`).
 */
import { useSelector } from "react-redux"

import { skillSetsService } from "../../../../data/services/skillSetsService"
import { openExternalUrl } from "./openExternalUrl"
import { useApiFetch } from "./useApiFetch"

export function useStripeDashboard(onError?: (error: unknown) => void) {
    const dashboard = useApiFetch<{ url?: string }>({
        service: skillSetsService.getDashboardExpressUrl,
        fetchOnMount: false,
        skipWhilePending: true,
        idleOnError: true,
        onSuccess: (data) => openExternalUrl(data?.url),
        onError,
    })
    const opening = useSelector(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (state: any) => !!state?.api?.getDashboardExpressUrl?.request
    )
    return { open: () => void dashboard.fetch(), opening }
}
